import { render, staticRenderFns } from "./OfferMailRadioButton.vue?vue&type=template&id=77d116a2&scoped=true&"
import script from "./OfferMailRadioButton.vue?vue&type=script&lang=ts&"
export * from "./OfferMailRadioButton.vue?vue&type=script&lang=ts&"
import style0 from "./OfferMailRadioButton.vue?vue&type=style&index=0&id=77d116a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77d116a2",
  null
  
)

export default component.exports